import { Card, Col, Row } from 'reactstrap'
import CommonTable from '../Common/CommonTable'
import { TableHeadOption } from '../../../../../Utils/Constants'
import { tableHeadOptionBody, tableHeadOptionData, tableHeadOptionHead } from '../../../../../Data/Tables/ReactstrapTable/BasicTable/BasicTable'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'

const TableHeadOptions = () => {
  return (
    <Col sm="6">
      <Card>
        <CardHeaderCommon title={TableHeadOption} span={tableHeadOptionData}/>
        <Row className="card-block">
          <Col sm="12" lg="12" xl="12">
            <CommonTable headData={tableHeadOptionHead}>
              {tableHeadOptionBody.map((data) => (
                <tr key={data.id}>
                  <th scope="row">{data.id}</th>
                  <td>{data.firstName}</td>
                  <td>{data.lastName}</td>
                  <td>{data.userName}</td>
                </tr>
              ))}
            </CommonTable>
          </Col>
        </Row>
      </Card>
    </Col>
  )
}

export default TableHeadOptions